<template>
	<div class="flight-details">
		<div class="flight-details__flight-time">
			<component
				:is="displayDepartureTime === '--' ? 'span' : 'time'"
				:datetime="displayDepartureTime"
			>
				{{ displayDepartureTime }}
			</component>
			<span>&nbsp;&ndash;&nbsp;</span>
			<component
				:is="displayArrivalTime === '--' ? 'span' : 'time'"
				:datetime="displayArrivalTime"
			>
				{{ displayArrivalTime }}
			</component>
			<span v-if="!departureTime && !arrivalTime">&nbsp;Uhr</span>
		</div>
		<div class="flight-details__stops">
			<span v-if="stops !== ' '">{{ stops }} •</span> <span v-if="totalFlightTime">{{ totalFlightTime }}</span>
		</div>
		<div
			v-if="airline"
			class="flight-details__airline"
		>
			{{ airline }}
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { pluralize } from '@/js/utils/utils';
import { formatFlightDuration } from '@/js/utils/dateTimeUtils';

type Props = {
	departureTime?: string;
	arrivalTime?: string;
	airline?: string;
	numberOfStops?: number;
	duration?: number;
};

const { numberOfStops, departureTime, arrivalTime, duration } = defineProps<Props>();
let totalFlightTime = null;
const displayDepartureTime = computed(() => {
	return departureTime || '--';
});

const displayArrivalTime = computed(() => {
	return arrivalTime || '--';
});

const stops = computed(() => {
	if (numberOfStops === 0) {
		return 'Direktflug';
	}
	if (!numberOfStops) {
		return ' ';
	}
	return pluralize(numberOfStops, 'Stop', 'Stops');
});
if (duration) {
	totalFlightTime = formatFlightDuration(duration, true);
}
</script>

<style lang="scss" scoped>
.flight-details {
	&__flight-time {
		margin-bottom: 0.4rem;

		& > time,
		span {
			font-weight: $font-weight-semibold;
			font-size: $font-small-1;
			line-height: 2.179rem;
		}
	}

	&__stops {
		font-weight: $font-weight-regular;
		font-size: $font-small-2;
		line-height: 1.907rem;
		margin-bottom: 1.6rem;
		color: $color-placeholder-text;
		min-height: 1.907rem;
	}

	&__airline {
		font-weight: $font-weight-semibold;
		font-size: $font-small-2;
		line-height: 1.907rem;
		overflow-x: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
</style>
